import pt from './pt.json'
import es from './es.json'
import en from './en.json'

export default {
  pt,
  es,
  en,
}
